import React, { useState } from 'react';
import style from './message-resp.module.scss';
import { Select } from '../../../../components/Select';
import { contentTypes } from '../../../content/constants';
import {
	SelectContent,
	labelMap,
} from '../../../../../soloJourney/properties/message/components';
import { useQuery, useAppAndBranchId, usePermissions } from '../../../../hooks';
import { api } from '../../../content/api';
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { Select as AntSelect } from 'antd';
import lodash from 'lodash';
import { AddContent } from '../../../../../soloJourney/properties/message/components/AddContent';
import { CircleCrossIcon } from '../../../../icons';
import { MessageRespAction } from './MessageResp';

type AddMessageProps = {
	closeAddMessage: () => void;
	trigger: (action: MessageRespAction) => void;
	selectedContentIds: string[];
};

export function AddMessage(props: AddMessageProps) {
	const canCreate = usePermissions('content.Create')
	const { closeAddMessage, selectedContentIds } = props;
	const [contentType, setContentType] = useState('text');
	const [contentId, setContentId] = useState('');
	const [appId, branchId] = useAppAndBranchId();
	const [isAddOpen, setIsAddOpen] = useState(false);

	let { data: contents, refetch } = useQuery(
		() => api.getContents(appId, branchId, contentType),
		contentType,
		(contentType as any) !== '',
	);
	contents = contents ?? [];

	const styles: Record<string, string> = {
		'--select-bg': 'none',
		'--select-width': '140px',
		'--select-space': '6px 8px',
		'--select-top': '13px',
		'--select-chat-border': '1px solid #DDE2EC',
	};

	return (
		<div className={style.addMessage}>
			<div className={style.main}>
				<div style={styles}>
					<Select
						placeholder="Select Content Type"
						value={contentType}
						onSelect={(value: any) => {
							setContentType(value);
							setContentId('');
						}}
						options={contentTypes}
					/>
				</div>
				<div className={style.contentSelect}>
					<SelectContent
						classes="qna-select"
						placeholder="Select Content"
						value={contentId}
						setIsAddOpen={setIsAddOpen}
						contentType={contentType}
						onChange={(value) => {
							props.trigger({
								op: 'add',
								field: 'messages',
								payload: value,
							});
						}}
					>
						{contents
							.filter((item) => !selectedContentIds.includes(item.contentId))
							.map((el, i) => {
								return (
									<AntSelect.Option
										key={el.contentId}
										value={el.contentId}
										label={el.contentId}
									>
											<div className="textOption">
												<p className="text-ellipsis">
													<span>
														{(el.contentValue as any)[labelMap[el.contentType]]}
													</span>
												</p>
												<hr />
											</div>
									</AntSelect.Option>
								);
							})}
					</SelectContent>
				</div>
				<button onClick={closeAddMessage}>
					<CircleCrossIcon width="16" height="16" stroke="#292D32" />
				</button>
			</div>
			<div className={style.ruler} />
			<AddContent
				contentType={contentType}
				refetchContent={refetch}
				close={() => setIsAddOpen(false)}
				isOpen={isAddOpen}
				onCreate={(contentId) => {
					props.trigger({
						op: 'add',
						field: 'messages',
						payload: contentId,
					});
				}}
			/>
		</div>
	);
}

export function AddContentType(props: { onClick: () => void; contentType: string }) {
	return (
		<button
			onClick={(e) => {
				e.stopPropagation();
				props.onClick();
			}}
			className="addHeader"
		>
			<img src={AddIcon} alt="add" />
			<p>Add {lodash.startCase(props.contentType)}</p>
		</button>
	);
}
